<template >
<div class="col-12 backgroundForm">
    <div v-if="!habilitaReg">
        <button class="btn btn-success col-12 col-md-2 offset-md-10" @click="logout">Iniciar session</button>
        &nbsp;
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Registro de Solicitud de Certificación</h4>        
        </div>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-gral" data-toggle="tab" href="#nav-reg-cert" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="plus" /> Registro Solicitud</a>

                <a class="nav-item nav-link" id="nav-update-gral" data-toggle="tab" href="#nav-seg-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Seguimiento Solicitud</a>

            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Asignacion de presupuesto anual -->
            <div class="tab-pane fade show active" id="nav-reg-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Registro Solicitud
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Cédula Identidad (sin expedido)</label>
                        <input type="text" min="3" max="12" style="text-transform: uppercase;" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="solicitud_certificado.cedula">
                    </div>
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Expedido</label>
                        <select class="form-control" name="t_expedido" id="t_expedido" v-model="solicitud_certificado.expedido">
                            <option v-for="xp in expedidos" :key="xp.id" :value="xp.id">{{ xp.detail }}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Nombres</label>
                        <input type="text" name="date_sol" id="date_sol" class="form-control" autocomplete="off" style="text-transform: uppercase;" v-model="solicitud_certificado.nombres">
                    </div>
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Apellido Paterno</label>
                        <input type="text" name="date_sol" id="date_sol" class="form-control" autocomplete="off" style="text-transform: uppercase;" v-model="solicitud_certificado.paterno">
                    </div>
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Apellido Materno</label>
                        <input type="text" name="date_sol" id="date_sol" class="form-control" autocomplete="off" style="text-transform: uppercase;" v-model="solicitud_certificado.materno">
                    </div>
                    
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Número Deposito</label>
                        <input type="text" min="3" max="50" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="solicitud_certificado.n_deposito">
                    </div>
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Fecha Deposito</label>
                        <input type="date" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="solicitud_certificado.fecha_deposito">
                    </div>
                    <div class="form-group col-12 col-md">
                        <label for="t_file">Importe Bs.</label>
                        <input type="number" min="3" max="50" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="solicitud_certificado.importe">
                    </div>
                    
                    <!-- <div class="form-group col-12 col-md">
                        <label for="t_file">Pertenece FFAA</label>
                        <select class="form-control" name="t_expedido" id="t_expedido" v-model="solicitud_certificado.pertenece_fa">
                            <option value="N">NO</option>
                            <option value="S">SI</option>
                        </select>
                    </div> -->

                </div>
                
                <div align="center" class="col-12 col-sm" id="imageDeposito">
                    <image-uploader
                    :preview="true"
                    :className="['fileinput' ,{ 'fileinput--loaded': hasImage }]"
                    capture="environment"
                    :debug="1"
                    doNotResize="gif"
                    :scaleRatio="scaleImage"
                    :quality="qualityImage"
                    :autoRotate="true"
                    outputFormat="verbose"
                    @input="setImage"
                >
                
                    <label for="fileInput" slot="upload-label" class="col">
                    <div><font-awesome-icon icon="camera-retro" size="3x"></font-awesome-icon></div>
                    <span class="upload-caption">{{
                        hasImage ? "Cambiar" : "Seleccionar Foto Deposito"
                    }}</span>
                    </label>
                    </image-uploader>
                </div>

                <button class="btn btn-warning col-12 col-md-4 offset-md-4" @click="mSaveSolicitud" :disabled="is_disabled"><font-awesome-icon icon="save" /> Solicitar</button>

                <br><br>
                <div align="center"><h3>Codigo de Recepción : {{ codigo_recepcion }}</h3></div>
                <br>
            </div>
            
            <!-- reformulacion del poa -->
            <div class="tab-pane fade" id="nav-seg-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>                
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-warning" align="center">
                        Seguimiento estado de trámite
                    </div>
                </div>

                 

                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Codigo de Trámite</label>
                        <input type="text" min="3" max="20" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="codigo_busqueda">
                    </div>
                </div>

                <button class="btn btn-success col-12 col-md-4 offset-md-4" @click="mBuscaDocumento"> <font-awesome-icon icon="search" /> Buscar</button>
                <br><br>
                <div class="table-responsive" v-if="resultado_busqueda.estado!=='I'">
                    <p v-if="fecha_hoy===resultado_busqueda.fecha_reg && resultado_busqueda.estado_original==='P'"><b>Nota:</b> En esta opcion podra modificar por una sola vez y durante el mismo día de registro si algún dato se registro erroneamente, bajo su responsabilidad.</p>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Cedula Identidad</th>
                                <th>Nombres</th>
                                <th>Paterno</th>
                                <th>Materno</th>
                                <th>Depósito</th>
                                <th>Fecha Depósito</th>
                                <th v-if="edita_document==='N'">Estado</th>
                                <th v-if="edita_document==='N'">Observacion</th>
                                <th v-if="fecha_hoy===resultado_busqueda.fecha_reg && resultado_busqueda.estado_original==='P'">Editar</th>
                            </tr>
                            <tr>
                                <td>
                                    <span v-if="edita_document==='N'">{{ resultado_busqueda.carnet }}</span>
                                    <input type="text" v-else class="form-control" v-model="resultado_busqueda.carnet" id="edita_carnet" />
                                </td>
                                <td>
                                    <span v-if="edita_document==='N'">{{ resultado_busqueda.nombres }}</span>
                                    <input type="text" v-else class="form-control" v-model="resultado_busqueda.nombres" id="edita_nombres" />
                                </td>
                                <td>
                                    <span v-if="edita_document==='N'">{{ resultado_busqueda.paterno }}</span>
                                    <input type="text" v-else class="form-control" v-model="resultado_busqueda.paterno" id="edita_paterno" />
                                </td>
                                <td>
                                    <span v-if="edita_document==='N'">{{ resultado_busqueda.materno }}</span>
                                    <input type="text" v-else class="form-control" v-model="resultado_busqueda.materno" id="edita_materno" />
                                </td>
                                <td>
                                    <span v-if="edita_document==='N'">{{ resultado_busqueda.n_deposito }}</span>
                                    <input type="number" v-else class="form-control" v-model="resultado_busqueda.n_deposito" id="edita_deposito" />
                                </td>
                                <td>
                                    <span v-if="edita_document==='N'">{{ resultado_busqueda.fecha_deposito }}</span>
                                    <input type="date" v-else class="form-control" v-model="resultado_busqueda.fecha_deposito" id="edita_deposito" />
                                </td>
                                <td :class="this.resultado_busqueda.color" v-if="edita_document==='N'">
                                    {{ resultado_busqueda.estado }}
                                </td>
                                <td v-if="edita_document==='N'">
                                    {{ resultado_busqueda.observacion }}
                                </td>
                                <td v-if="fecha_hoy===resultado_busqueda.fecha_reg && resultado_busqueda.estado_original==='P'">
                                    <span v-if="edita_document==='N'">
                                        <button class="btn btn-outline-warning" @click="mEditaReg" ><font-awesome-icon icon="edit" /></button>
                                    </span>
                                    <span v-if="edita_document==='S'">
                                        <button class="btn btn-outline-success" @click="mUpdateReg" :disabled="is_disabled_update"><font-awesome-icon icon="save" /></button>
                                        <button class="btn btn-outline-danger" @click="mCancelEdit" :disabled="is_disabled_update" ><font-awesome-icon icon="times-circle" /></button>
                                    </span>
                                </td>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
                
    </div>
    <div v-else>
        <div align="center">
            <img width="25%" src="@/assets/images/logo_dgcp.png" class="img-fluid" alt="Responsive image">
        </div>
        <h1 class="display-4" align="center">Los registros solo se habilitan de Lunes a Viernes <br>Gracias por su comprensión</h1>
    </div>
    
    <!-- aqui el div de modal al ingresar -->
    
    <modal-view :id-modal='modalAnuncio' :title="titleModal" :content="contentModal" :is-large="largeModal"></modal-view>
    
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
const qs= require('qs');
import modalLoading from '../modal/modalLoading';
import modalView from '../modal/modalView';

export default {
    name: 'certificados',
    data(){
        return {
            edita_document:'N',
            modalAnuncio:'idModalAuto',
            titleModal:'Anuncio',
            largeModal:true,
            hasImage:false,
            scaleImage:0.85,
            qualityImage:0.9,
            solicitud_certificado:{
                cedula:'',
                expedido:'',
                paterno:'',
                materno:'',
                nombres:'',
                n_deposito:0,
                fecha_deposito:'',
                importe:0,
                fotografia:'',
                pertenece_fa:'N'
            },
            contador_solicitudes:0,
            modalAuth:'autenticate',
            modalTitle:'Autenticando',
            header:[],
            config:[],
            codigo_recepcion:'SIN DATOS',
            is_disabled:false,
            codigo_busqueda:'',
            resultado_busqueda:{
                estado:'I'
            },
            expedidos:[
                {id:'LP', detail:'LA PAZ'},
                {id:'CBBA', detail:'COCHABAMBA'},
                {id:'SC', detail:'SANTA CRUZ'},
                {id:'OR', detail:'ORURO'},
                {id:'PT', detail:'POTOSI'},
                {id:'CH', detail:'CHUQUISACA'},
                {id:'TJ', detail:'TARIJA'},
                {id:'BN', detail:'BENI'},
                {id:'PN', detail:'PANDO'}
            ],
            habilitaReg:false,
            contentModal:'',
            fecha_hoy:'',
            is_disabled_update:false
        }
    },
    mounted(){
        this.header=Vue.urlP.setHeaders(Vue.auth.getToken());
        this.config=axios.create(this.header);
        this.mChargeInit();
        this.mChargeModal(this.modalAnuncio);
        this.obtieneDia();
    },
    methods:{
        mValidateUpdate(){
            try {
                let aux_cedula=this.resultado_busqueda.carnet.trim();
                console.log(aux_cedula);
                if(aux_cedula.length===0){
                    toastr.warning('Debe indicar un número de cedula de Identidad', 'Advertencia');   
                    return false;
                }
                let aux_paterno=this.resultado_busqueda.paterno.trim();
                if(aux_paterno.length===0){
                    toastr.warning('Indique el Apellido Paterno', 'Advertencia');   
                    return false;
                }
                let aux_materno=this.resultado_busqueda.materno.trim();
                if(aux_materno.length===0){
                    toastr.warning('Indique el Apellido Materno', 'Advertencia');   
                    return false;
                }
                let aux_nombres=this.resultado_busqueda.nombres.trim();
                if(aux_nombres.length===0){
                    toastr.warning('Indique el Nombre de la Persona', 'Advertencia');   
                    return false;
                }
                
                if(this.resultado_busqueda.n_deposito<=0){
                    toastr.warning('Indique el Número de Deposito', 'Advertencia');   
                    return false;
                }
                if(this.resultado_busqueda.fecha_deposito.length<=0){
                    toastr.warning('Debe indicar la fecha del Deposito', 'Advertencia');   
                    return false;
                }
                return true;
                
            } catch (error) {
                console.log(error);
            }
            
        },
        async mUpdateReg(){
            if(this.mValidateUpdate()){
                let message = {
                title: 'Actualización de registro',
                body: `Desea actualizar su solicitud de la persona <b>${this.resultado_busqueda.nombres} ${this.resultado_busqueda.paterno}</b> con cedula de identidad <b>${this.resultado_busqueda.carnet}</b>, con el siguiente depósito No.<b>${this.resultado_busqueda.n_deposito}</b> Fecha: <b>${this.resultado_busqueda.fecha_deposito}</b> `
                };

                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then( async (msg) =>{
                if(msg){
                    try {
                        console.log('se envia la actualizacion de registro al servidor')
                        // this.title_m="Registrando";
                        // this.activeModal(this.id_m_progress);
                        this.is_disabled_update=true;

                        let rsc=await axios.post(`updateSolicitudClient`, qs.stringify(this.resultado_busqueda));
                        console.log(rsc);
                        if(rsc.data[0].status){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(rsc.data[0].respuesta, 'Exito');
                            this.edita_document='N';
                        }else{                            
                            // solo mostramos el mensaje de error
                            toastr.error(`${rsc.data[0].respuesta}`, 'Error');
                            this.edita_document='N';
                        }
                        setTimeout(()=>{
                            this.is_disabled_update=false;
                        }, 5000)

                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            // this.inactiveModal(this.id_m_progress);
                            this.is_disabled_update=false;
                        }, 5000)
                    }
                }else{
                    console.log('se ha rechazado el registro de solicitud');
                }
            })
            }
        },
        mCancelEdit(){
            this.edita_document='N';
        },
        mEditaReg(){
            this.edita_document='S';
        },
        setImage(output){
            this.hasImage=true;
            this.solicitud_certificado.fotografia=output.dataUrl;
            
            // console.log(this.ship.image);
        },
        async obtieneDia(){
            let finde=await axios.get(`getDaySem?api_token=${Vue.auth.getToken()}`);
            console.log(finde.data);
            if(finde.data.dia==='Sabado' || finde.data.dia==='Domingo' || parseInt(finde.data.dia_numero)===6 || parseInt(finde.data.dia_numero)===0){
                console.log('dia bloqueado')
                 this.habilitaReg=true;
            }
            // if(finde.data.dia==='Viernes' || finde.data.dia==='Jueves' || parseInt(finde.data.dia_numero)===5 || parseInt(finde.data.dia_numero)===4){
            //     console.log('dia bloqueado')
            //     this.habilitaReg=true;
            // }
        },
        async mBuscaDocumento(){
            this.resultado_busqueda={estado:'I'};
            if(this.codigo_busqueda.length>0){
                let bcr=await axios.get(`getDocumentStatus/${this.codigo_busqueda}?api_token=${Vue.auth.getToken()}`);
                        // console.log(adp);
                        if(bcr.data.length>0){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                        //    console.log(bcr.data);
                           let estado_aux;
                           let color_status='';
                           switch(bcr.data[0].estado){
                                case 'P':
                                    estado_aux='EN PROCESO';
                                    color_status='alert alert-warning';
                                    break;
                                case 'O':
                                    estado_aux='OBSERVADO';
                                    color_status='alert alert-danger';
                                    break;
                                case 'F':
                                    estado_aux='FINALIZADO';
                                    color_status='alert alert-success';
                                    break;
                           }
                            this.resultado_busqueda.carnet=bcr.data[0].carnet;
                            this.resultado_busqueda.nombres=bcr.data[0].nombres;
                            this.resultado_busqueda.paterno=bcr.data[0].paterno;
                            this.resultado_busqueda.materno=bcr.data[0].materno;
                            this.resultado_busqueda.n_deposito=bcr.data[0].n_deposito;
                            this.resultado_busqueda.fecha_deposito=bcr.data[0].fecha_deposito;
                            this.resultado_busqueda.estado=estado_aux;
                            this.resultado_busqueda.estado_original=bcr.data[0].estado;
                            this.resultado_busqueda.color=color_status;
                            this.resultado_busqueda.observacion=bcr.data[0].observacion;
                            this.resultado_busqueda.fecha_reg=bcr.data[0].fecha_reg;
                            this.resultado_busqueda.codigo_recepcion=bcr.data[0].codigo_recepcion;

                        }else{
                            // solo mostramos el mensaje de error
                            toastr.error(`No existen registros`, 'Error');
                        }
                        setTimeout(()=>{
                            this.is_disabled=false;
                        }, 5000)
            }else{
                toastr.warning("Indique el numero de documento a buscar", 'Advertencia');
            }
        },
        logout(){
            // this.$auth.destroyToken();
            this.$router.push('/auth/login');
            // this.$store.dispatch('sessionDestroy',true);
        },
        mChargeInit(){
            let nd=new Date();
            let anio=nd.getFullYear();
            let mes=nd.getMonth()+1;
            mes = mes<10 ? `0${mes}`:mes;
            let dia=nd.getDate() < 10 ? `0${nd.getDate()}`:nd.getDate();
            this.solicitud_certificado.fecha_deposito=`${anio}-${mes}-${dia}`;
            this.fecha_hoy=`${anio}-${mes}-${dia}`;
            // console.log(this.solicitud_certificado.fecha_deposito);
            // acargamos el comunicado en aca
            this.contentModal=`<h5 align="center">PROCEDIMIENTO PARA OBTENER LA CERTIFICACIÓN DE NO HABER SIDO DADO DE BAJA - DPTO. VI ENS. E INST. NAV.</h5>
                <p class="lead">1. Realice el depósito bancario en la Cuenta <b class="bg-warning">Banco Unión N° 10000023896117</b> Ministerio de Defensa-Armada Boliviana de <b class="bg-warning">15 Bs.</b> a nombre del postulante, con las iniciales de D-6 al final del nombre.</p>
                <p class="lead">2. Registre sus  datos: CI., Nombres, Apellidos, Nro. de Boleta, etc.</p>
                <p class="lead">3. El registro genera un código el cual le permite realizar el seguimiento del trámite en línea (vía web), para su posterior recojo.</p>

                <p class="lead">
                  <mark>Nota:</mark> <span class="text-danger">La boleta de depósito bancario <b>ORIGINAL</b> tiene una <b>validez de 5 dias</b> a partir del registro para entregar y recoger la certificación.</span>
                </p>
                <p class="lead">
                  <mark>Nota:</mark> Anote en un lugar seguro el número o codigo de recepción.
                </p>`;
            
        },
        mValidateSolicitud(){
            let aux_cedula=this.solicitud_certificado.cedula.trim();
            if(aux_cedula.length===0){
                toastr.warning('Debe indicar un número de cedula de Identidad', 'Advertencia');   
                return false;
            }
            let aux_expedido=this.solicitud_certificado.expedido.trim();
            if(aux_expedido.length===0){
                toastr.warning('Indique el lugar de expedido', 'Advertencia');   
                return false;
            }
            let aux_paterno=this.solicitud_certificado.paterno.trim();
            if(aux_paterno.length===0){
                toastr.warning('Indique el Apellido Paterno', 'Advertencia');   
                return false;
            }
            let aux_materno=this.solicitud_certificado.materno.trim();
            if(aux_materno.length===0){
                toastr.warning('Indique el Apellido Materno', 'Advertencia');   
                return false;
            }
            let aux_nombres=this.solicitud_certificado.nombres.trim();
            if(aux_nombres.length===0){
                toastr.warning('Indique el Nombre de la Persona', 'Advertencia');   
                return false;
            }
            
            if(this.solicitud_certificado.n_deposito<=0){
                toastr.warning('Indique el Número de Deposito', 'Advertencia');   
                return false;
            }
            if(this.solicitud_certificado.fecha_deposito.length<=0){
                toastr.warning('Debe indicar la fecha del Deposito', 'Advertencia');   
                return false;
            }
            if(this.solicitud_certificado.importe<=0){
                toastr.warning('Indique el importe del deposito', 'Advertencia');   
                return false;
            }
            let aux_fotografia=this.solicitud_certificado.fotografia.trim();
            if(aux_fotografia.length===0){
                toastr.warning('Seleccione la imagen del Deposito', 'Advertencia');   
                return false;
            }
            return true;
        },
        mSaveSolicitud(){
            if(this.mValidateSolicitud()){
                let message = {
                title: 'Registro de Solicitud',
                body: `Desea enviar su solicitud de la persona <b>${this.solicitud_certificado.nombres} ${this.solicitud_certificado.paterno}</b> con cedula de identidad <b>${this.solicitud_certificado.cedula}</b>, con el siguiente depósito No.<b>${this.solicitud_certificado.n_deposito}</b> Fecha: <b>${this.solicitud_certificado.fecha_deposito}</b>, Importe Bs: <b>${this.solicitud_certificado.importe}</b> `
                };

                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });

            npr.then( async (msg) =>{
                if(msg){
                    try {
                        console.log('se envia el registro al servidor')
                        // this.title_m="Registrando";
                        // this.activeModal(this.id_m_progress);
                        this.is_disabled=true;

                        let rsc=await axios.post(`registerSolicitud`, qs.stringify(this.solicitud_certificado));
                        // console.log(adp);
                        if(rsc.data.status){
                            // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                            toastr.success(rsc.data.respuesta, 'Exito');
                            this.codigo_recepcion=rsc.data.codigo;
                            // eliminar al documento de la lista
                            this.solicitud_certificado.nombres='';
                            this.solicitud_certificado.paterno='';
                            this.solicitud_certificado.materno='';
                            this.solicitud_certificado.n_deposito='';
                            this.solicitud_certificado.importe=0;
                            this.solicitud_certificado.fotografia='';
                            this.setImage('');
                            this.solicitud_certificado.fotografia=null;
                            this.hasImage=false;
                            document.getElementsByClassName('img-preview')[0].src="";
                        }else{                            
                            // solo mostramos el mensaje de error
                            toastr.error(`${rsc.data.respuesta}`, 'Error');
                        }
                        setTimeout(()=>{
                            this.is_disabled=false;
                        }, 5000)

                    } catch (error) {
                        toastr.error('Consulte al administrador', 'Error');
                        setTimeout(()=>{
                            // this.inactiveModal(this.id_m_progress);
                            this.is_disabled=false;
                        }, 5000)
                    }
                }else{
                    console.log('se ha rechazado el registro de solicitud');
                }
            })
            }
        },
        mChargeModal(e){
            console.log('levantando el modal')
            $("#" + e).modal("show");
        },
        mViewLoad(){
            $('#'+this.modalAuth).modal('show');
        },
        mHideLoad(){
            $('#'+this.modalAuth).modal('hide');
        }
    },
    components:{
        'modal-loading':modalLoading,
        'modal-view':modalView
    }
}
</script>

<style scoped>
.backgroundForm{
    background: #fff;
    padding-bottom: 15px;
    padding-top: 10px;
    border-radius: 10px;
}
</style>

<style>
#imageDeposito img{
    width: 250px;
}

#fileInput {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/certificados/Certificados.vue